<template>
<div id="app">
	<div id="header">
		<div class="wrapper">
      <global-header/>
			<div id="breadcrumb" class="clearfix">
        <ul>
					<li><a href="/../index.html">HOME</a></li>
					<li>&gt;</li>
          <li v-for="crumb in breadcrumbs" :key="crumb.name">
          <div v-if="!crumb.active">
            <router-link :to="crumb.path">{{crumb.name}}</router-link>&nbsp;&gt;&nbsp;
          </div>
          <div v-else><a>{{crumb.name}}</a></div>
          </li>
        </ul>
			</div>
			<div class="clear"></div>
		</div><!-- .wrapper -->
	</div><!-- #header -->
	<div id="wrapper">
		<div id="contenner">
			<!-- コンテンツ -->
      <router-view name="mainview" :categorySet="sortCategories"/>
			<!-- サイドバー -->
			<div id="catalog-sidebar">
        <item-search/>
        <router-view name="side" :categorySet="sortCategories"/>
      </div>
    </div>
    <div id="side-bottom"></div>
    <div id="top_btn"><a href="#top"><img class="imgover" src="/images/top_btn_off.gif" /></a></div>
    <div class="clear"></div>
  </div><!-- wrapper -->
  <global-footer/>
</div>
</template>

<script>
  import ItemSearch from '@/components/ItemSearch';
  import GlobalHeader from '@/components/GlobalHeader';
  import GlobalFooter from '@/components/GlobalFooter';

  export default {
    name: 'App',
    components: {
      ItemSearch,
      GlobalHeader,
      GlobalFooter
    },
    data: function () {
      return {
        title: "商品カタログ",
        description: "当社で取り扱いのある商品のカタログを掲載しています。各種性能表が掲載されており、カタログPDFファイルをダウンロードすることもできます。機種一覧からカテゴリごとに分類された商品を選択することもできますし、フリーワード検索にも対応しております。",
        keywords: "建設機械,土木機械,掘削機,バックホー,油圧ショベル,レンタカー,道路機械,解体,林業,アタッチメント,高所作業車,整地,運搬機械",
        categories: [],
        breadcrumbs: [{
          name: '商品カタログ',
          path: '',
          active: true
        }],
        category_id: null,
        active_page_title: null
      }
    },
    head: {
      title: function () {
        return {
          inner: this.title
        }
      },
      meta: function () {
        return [
          {hid: 'description', name: 'description', content: this.description},
          {hid: 'keywords', name: 'keywords', content: this.keywords}
        ]
      }
    },
    mounted : function () {
      //meta
      this.$emit("updateHead")
      //categories
      var url = process.env.VUE_APP_URL + '/categories/search'
      var myToken = process.env.VUE_APP_TOKEN
      var myComId = process.env.VUE_APP_COMPANY_ID
      var params = {'limit': 1000, 'company_id': myComId}
      var myHeaders = {'Content-Type': 'application/json', 'Authorization': `Token ${myToken}` }
      fetch(url, {
        method: "POST",
        mode: "cors",
        headers : myHeaders,
        body: JSON.stringify(params)
      })
      .then(res => {
        return res.json()
      })
      .then(data => {
        this.categories = data
      })
      .catch(e => console.error(e))
    },
    created: function () {
    },
    methods : {
      setBreadcrumbs: function (id) {
        if(id == null){
          this.breadcrumbs = [
            {
              name: '商品カタログ',
              path: '',
              active: true
            }
          ]
          return
        }
        for(var i=0; i<this.sortCategories.length; i++){
          if(this.sortCategories[i].id == id){
            this.breadcrumbs = [
              {
                name: '商品カタログ',
                path: '/',
                active: false
              },
              {
                name: this.sortCategories[i].name,
                path: '/speclist2/' + this.sortCategories[i].name,
                active: true
              }
            ]
            break
          }
          for(var j=0; j<this.sortCategories[i].child.length; j++){
            if(this.sortCategories[i].child[j].id == id){
              this.breadcrumbs = [
                {
                  name: '商品カタログ',
                  path: '/',
                  active: false
                },
                {
                  name: this.sortCategories[i].name,
                  path: '/speclist2/' + this.sortCategories[i].name,
                  active: false
                },
                {
                  name: this.sortCategories[i].child[j].name,
                  path: '',
                  active: true
                },
              ]
              break
            }
            for(var k=0; k<this.sortCategories[i].child[j].child.length; k++){
              if(this.sortCategories[i].child[j].child[k].id == id){
                this.breadcrumbs = [
                  {
                    name: '商品カタログ',
                    path: '/',
                    active: false
                  },
                  {
                    name: this.sortCategories[i].name,
                    path: '/speclist2/' + this.sortCategories[i].name,
                    active: false
                  },
                  {
                    name: this.sortCategories[i].child[j].child[k].name,
                    path: '/list/' + this.sortCategories[i].child[j].child[k].id,
                    active: false
                  },
                  {
                    name: this.active_page_title,
                    path: '',
                    active: true
                  },
                ]
                break
              }   
            }
          }
        }
      }
    },
    computed: {
      sortCategories: function() {
        var cat = this.categories
        // id順にソート（読み込み順を守るため）
        /*
        cat.sort(function(a,b){
          let r = 0
          if(a['id'] < b['id']){r=-1}
          else if(a['id'] > b['id']){r=1}
          return r
        })
        */
        // position順にソートに変更
        cat.sort(function(a,b){
          let r = 0
          if(a['position'] < b['position']){r=-1}
          else if(a['position'] > b['position']){r=1}
          return r
        })

        var cat2h = {}; // idをキーにしたhash
        var mother_key = 0;
        for(var i=0;i<cat.length;i++){
          cat[i].show = false;
          cat[i].child = [];
          cat2h[cat[i].id] = cat[i];
        }
        for(i=0;i<cat.length;i++){
          mother_key = cat[i].category_id;
          if(mother_key){
            cat2h[mother_key].child.push(cat[i]);
          }
        }
        var catout = []
        for(var key in cat2h){
          if(!cat2h[key].category_id){
            catout.push(cat2h[key]);
          }
        }
        return catout;
      }
    },
    watch: {
      'title': function (){
        this.$emit("updateHead")
      },
      'category_id': function () {
        this.setBreadcrumbs(this.category_id)
      },
      'active_page_title': function () {
        this.setBreadcrumbs(this.category_id)
      }
    }
  }
</script>
